// Constants
import { NavView } from "@ms/uno-constants/lib/local/LeftNavConstants";
// Controls
import { Dropdown } from "@ms/planner-generic-controls/lib/local/dropdown/Dropdown";
import { CheckMark, Send, TaskListSquareLtr } from "@ms/planner-generic-controls/lib/local/icons";
// Styles
import { useSwitchViewDropdownStyles } from "./SwitchViewDropdown.styles";
// Utilities
import * as React from "react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
export const SwitchViewDropdown = ({ currentView, onChange, className, isPublisherViewVisible })=>{
    const styles = useSwitchViewDropdownStyles();
    if (!isPublisherViewVisible && currentView !== NavView.PublisherView) {
        return null;
    }
    const options = [
        {
            key: NavView.TasksView,
            text: Strings.LeftNav_DropdownTasksViewOption,
            icon: /*#__PURE__*/ React.createElement(TaskListSquareLtr, {
                className: styles.icon
            })
        },
        {
            key: NavView.PublisherView,
            text: Strings.LeftNav_SwitchViewPublishing,
            icon: /*#__PURE__*/ React.createElement(Send, {
                className: styles.icon
            })
        }
    ];
    const handleOptionChange = (key)=>{
        const navKey = key;
        onChange?.(navKey);
    };
    const onRenderOption = (option)=>{
        const isSelected = option.key === currentView;
        return /*#__PURE__*/ React.createElement("span", {
            className: isSelected ? styles.option : `${styles.option} ${styles.unselectedOption}`
        }, isSelected && /*#__PURE__*/ React.createElement(CheckMark, {
            className: styles.icon
        }), option.icon, /*#__PURE__*/ React.createElement("span", null, option.text));
    };
    const onRenderTitle = (selectedOption)=>{
        const option = selectedOption ?? options.find((o)=>o.key === currentView);
        return /*#__PURE__*/ React.createElement("span", {
            className: `${styles.option} ${styles.title}`
        }, option?.icon, /*#__PURE__*/ React.createElement("span", null, option?.text));
    };
    return /*#__PURE__*/ React.createElement(Dropdown, {
        options: options,
        selectedKey: currentView,
        onRenderOption: onRenderOption,
        onRenderTitle: onRenderTitle,
        onOptionChange: handleOptionChange,
        className: className ? `${styles.root} ${className}` : styles.root,
        "data-testid": "switch-view-dropdown",
        customStyles: {
            dropdownItem: styles.option,
            dropdown: styles.dropdown,
            root: styles.root
        },
        placeholder: Strings.LeftNav_DropdownTasksViewOption
    });
};
